import {HttpClientModule} from '@angular/common/http';
import {NgModule} from '@angular/core';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {BrowserModule} from '@angular/platform-browser';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {AngularEditorModule} from '@kolkov/angular-editor';
import {EffectsModule} from '@ngrx/effects';
import {StoreModule} from '@ngrx/store';
import {StoreDevtoolsModule} from '@ngrx/store-devtools';
import {NgxJsonLdModule} from '@ngx-lite/json-ld';
import {Angulartics2Module} from 'angulartics2';
import {ButtonsModule} from 'ngx-bootstrap/buttons';
import {CarouselModule} from 'ngx-bootstrap/carousel';
import {ModalModule} from 'ngx-bootstrap/modal';
import {CookieService} from 'ngx-cookie-service';
import {NgxMaskModule} from 'ngx-mask';
import {ToastrModule} from 'ngx-toastr';
import {NgxUiLoaderModule} from 'ngx-ui-loader';
import {environment} from '../environments/environment';
import {AppRoutingModule} from './app-routing.module';
import {AppComponent} from './app.component';
import {CourseComponent} from './course/course.component';
import {LectureComponent} from './course/lecture/lecture.component';
import {LessonComponent} from './course/lesson/lesson.component';
import { QaComponent } from './course/qa/qa.component';
import {ExcerptPipe} from './excerpt.pipe';
import {FormHelpersModule} from './form-helpers/form-helpers.module';
import {HomeComponent} from './home/home.component';
import { InstructorNamePipe } from './instructor-name.pipe';
import { InstructorComponent } from './instructor/instructor.component';
import {PageContentFilterPipe} from './page-content-filter.pipe';
import {SimpleMdPipe} from './simple-md.pipe';
import {metaReducers, reducers} from './state';
import {AnalyticsEffects} from './state/analytics/effects';
import {CourseEffects} from './state/courses/effects';
import {NotesEffects} from './state/notes/effects';
import {StickyElementComponent} from './sticky-element/sticky-element.component';

@NgModule({
	declarations: [
		AppComponent,
		CourseComponent,
		LessonComponent,
		LectureComponent,
		PageContentFilterPipe,
		StickyElementComponent,
		SimpleMdPipe,
		HomeComponent,
		ExcerptPipe,
		InstructorComponent,
		QaComponent,
		InstructorNamePipe,
	],
	entryComponents: [
	],
	imports: [
		BrowserModule,
		AppRoutingModule,
		HttpClientModule,
		FormsModule,
		ReactiveFormsModule,
		BrowserAnimationsModule, // required animations module
		ToastrModule.forRoot(), // ToastrModule added
		NgxUiLoaderModule,
		ButtonsModule.forRoot(),
		ModalModule.forRoot(),
		CarouselModule.forRoot(),
		NgxMaskModule.forRoot(),
		FormHelpersModule,
		StoreModule.forRoot(reducers, {
			metaReducers,
			runtimeChecks: {
				strictStateImmutability: true,
				strictActionImmutability: true,
			}
		}),
		EffectsModule.forRoot([CourseEffects, NotesEffects, AnalyticsEffects]),
		StoreDevtoolsModule.instrument({ maxAge: 25, logOnly: environment.production }),
		AngularEditorModule,
		Angulartics2Module.forRoot(),
		NgxJsonLdModule,
	],
	exports: [
	],
	providers: [
		CookieService,
	],
	bootstrap: [AppComponent]
})
export class AppModule {}
